// helpers/assetListCustomComponents.js

import OccupancyList from '../StaticComponent/OccupancyList';
import MachineTypeList from '../StaticComponent/MachineTypeList';
import VehicleTypeList from '../StaticComponent/VehicleTypeList';
import ProductRateList from '../StaticComponent/ProductRateList';
import OccupationList from '../StaticComponent/OccupationList';
import OtherMasterList from '../StaticComponent/OtherMasterList';
import AgeRangemasterList from '../StaticComponent/AgeRangemasterList';
import VoyageMasterList from '../StaticComponent/VoyageMasterList';
import AssetTypeList from '../StaticComponent/AssetTypeList';
import CubicCapacityList from '../StaticComponent/CubicCapacityList';
import ProjectTypeList from '../StaticComponent/ProjectTypeList';
import VehicleMake from '../StaticComponent/VehicleMake';
import LocationFromMaster from '../StaticComponent/LocationFromMaster';
import VehicleVarient from '../StaticComponent/VehicleVarient';
import VehicleModel from '../StaticComponent/VehicleModel';
import CommonRiskFactorList from '../StaticComponent/CommonRiskFactorList';
import SectionmasterList from '../StaticComponent/SectionmasterList';

export const customComponentMap = {
    cubicCapacity: CubicCapacityList,
    vehicleMake: VehicleMake,
    vehicleVariant: VehicleVarient,
    vehicleModel: VehicleModel,
    occupancy: OccupancyList,
    machineType: MachineTypeList,
    vehicleType: VehicleTypeList,
    productRates: ProductRateList,
    occupations: OccupationList,
    section: SectionmasterList,
    others: OtherMasterList,
    ageRange: AgeRangemasterList,
    voyages: VoyageMasterList,
    assetType: AssetTypeList,
    projectType: ProjectTypeList,
    location: LocationFromMaster,
    boilerType: CommonRiskFactorList,
    modeOfTransit: CommonRiskFactorList,
    indemnityPeriod: CommonRiskFactorList,
    type: CommonRiskFactorList,
    age: CommonRiskFactorList,
    territory: CommonRiskFactorList,
    basisOfValuation: CommonRiskFactorList,
    description: CommonRiskFactorList,
    packingRf: CommonRiskFactorList,
    riskCovered: CommonRiskFactorList,
    testingPeriod: CommonRiskFactorList
};

export const customComponentSettings = {
    "vehicleMake": {
        'create_url': 'riskFactor/create',
        'get_url': 'riskFactor/getRiskFactorByProductId',
        'permission_key': 'riskFactors',
        'dataType': 'string',
        'riskFactor': 'vehicleMake',
        'formKey': 'vehicleMake'
    },
    "vehicleModel": {
        'create_url': 'vehichle/createVehicleModel',
        'get_url': 'vehichle/listVehicleModel',
        'permission_key': 'riskFactors',
        'dataType': 'string',
        'riskFactor': 'vehicleModel',
        'formKey': 'vehicleModel',
    },
    "vehicleVariant": {
        'get_url': 'vehichle/listVehicleVariant',
        'permission_key': 'riskFactors',
        'dataType': 'string',
        'riskFactor': 'vehicleVariant',
        'formKey': 'vehicleVariant',
    },
    "boilerType": {
        'create_url': 'boilerType/create',
        'update_url': 'boilerType/update',
        'get_url': 'boilerType/getboilerTypeList',
        'permission_key': 'riskFactors',
        'formKey': 'boilerType',
        'dataType': 'string',
        'riskFactor': 'boilerType',

    },
    "modeOfTransit": {
        'create_url': 'riskFactor/create',
        'update_url': 'riskFactor/update',
        'get_url': 'riskFactor/getRiskFactorByProductId',
        'permission_key': 'riskFactors',
        'dataType': 'string',
        'riskFactor': 'modeOfTransit',
        'formKey': 'modeOfTransit',
    },
    "indemnityPeriod": {
        'create_url': 'indemnityPeriod/create',
        'update_url': 'indemnityPeriod/update',
        'get_url': 'indemnityPeriod/getIndemnityPeriodList',
        'permission_key': 'riskFactors',
        'formKey': 'indemnityPeriod',
        'dataType': 'numeric',
        'riskFactor': 'indemnityPeriod',
    },
    "type": {
        'create_url': 'type/create',
        'update_url': 'type/update',
        'get_url': 'type/getTypeList',

        'permission_key': 'riskFactors',
        'formKey': 'type',
        'dataType': 'string',
        'riskFactor': 'Type',
    },
    "age": {
        'create_url': 'ageRiskFactor/create',
        'update_url': 'ageRiskFactor/update',
        'get_url': 'ageRiskFactor/getAgeList',
        'permission_key': 'riskFactors',
        'formKey': 'age',
        'dataType': 'numeric',
        'riskFactor': 'ageRiskFactor',
    },
    "location": {
        'create_url': 'customerLocation/create',
        'update_url': 'customerLocation/update',
        'get_url': 'customerLocation/list',
        'permission_key': 'location',
        'dataType': 'string',
        'riskFactor': 'location',
        'formKey': 'location',
    },
    "territory": {
        'create_url': 'riskFactor/create',
        'update_url': 'riskFactor/update',
        'get_url': 'riskFactor/getRiskFactorByProductId',
        'permission_key': 'riskFactors',
        'dataType': 'string',
        'riskFactor': 'territory',
        'formKey': 'territory',
    },
    "basisOfValuation": {
        'create_url': 'riskFactor/create',
        'update_url': 'riskFactor/update',
        'get_url': 'riskFactor/getRiskFactorByProductId',
        'permission_key': 'riskFactors',
        'dataType': 'string',
        'riskFactor': 'basisOfValuation',
        'formKey': 'basisOfValuation',
    },
    "description": {
        'create_url': 'description/create',
        'update_url': 'description/update',
        'get_url': 'description/getDescriptionList',
        'permission_key': 'riskFactors',
        'formKey': 'description',
        'dataType': 'string',
        'riskFactor': 'Description',
    },
    "packingRf": {
        'create_url': 'riskFactor/create',
        'update_url': 'riskFactor/update',
        'get_url': 'riskFactor/getRiskFactors',
        'permission_key': 'riskFactors',
        'dataType': 'string',
        'riskFactor': 'packingRf',
        'formKey': 'packingRf',
    },
    "riskCovered": {
        'create_url': 'riskFactor/create',
        'update_url': 'riskFactor/update',
        'get_url': 'riskFactor/getRiskFactorByProductId',
        'permission_key': 'riskFactors',
        'dataType': 'string',
        'riskFactor': 'riskCovered',
        'formKey': 'riskCovered',
    },
    "testingPeriod": {
        'create_url': 'riskFactor/create',
        'update_url': 'riskFactor/update',
        'get_url': 'riskFactor/getRiskFactorByProductId',
        'permission_key': 'riskFactors',
        'dataType': 'numeric',
        'riskFactor': 'testingPeriod',
        'formKey': 'testingPeriod',
    },
     "cubicCapacity": {
        'create_url': 'riskFactor/create',
        'update_url': 'riskFactor/update',
        'get_url': 'CubicCapacity/getCubicCapacityList',
        'permission_key': 'riskFactors',
        'dataType': 'string',
        'riskFactor': 'cubicCapacity',
        'formKey': 'cubicCapacity',
    },
      "occupancy": {
        'create_url': 'riskFactor/create',
        'update_url': 'riskFactor/update',
        'get_url': 'occupancy/occupanyListAgainstProductId',
        'permission_key': 'riskFactors',
        'dataType': 'string',
        'riskFactor': 'OccupancyList',
        'formKey': 'occupancy',
    }

};

export const getNewAssetRow = (policyId, groupId) => ({
    id: Date.now(),
    serialNo: null,
    locationName: null,
    location: null,
    locationAddress: null,
    occupancyDescription: null,
    compoundWall: null,
    buildingsIncPlinthNFoundation: null,
    plantAndMachinery: null,
    furnitureAndFittings: null,
    labEquipments: null,
    electricalInstallations: null,
    electronicEquipments: null,
    workInProgress: null,
    stock: null,
    computers: null,
    others: null,
    officeEquipments: null,
    totalLocationAssetValue: null,
    equipmentLocation: null,
    make: null,
    model: null,
    yearOfManufacture: null,
    underWarranty: null,
    assetValue: null,
    dateOfCommencementOfTransit: null,
    insuredBusinessDescription: null,
    incoTerms: null,
    voyageType: null,
    voyageDetails: null,
    cargoDetails: null,
    packaging: null,
    invoiceNoAndDate: null,
    quantity: null,
    marksAndNumbers: null,
    conveyance: null,
    billOfLadingAndDate: null,
    vesselNameAndVoyageNo: null,
    additionalDetails: null,
    voyageFromIncLoadPortOrAirport: null,
    to: null,
    fromCountry: null,
    toCountry: null,
    basisOfValuation: null,
    invoiceCurrency: null,
    exchangeRate: null,
    cargoSumInsured: null,
    dutySumInsured: null,
    annualTurnover: null,
    perSendingLimit: null,
    perLocationLimit: null,
    pincode: null,
    riskLocation: null,
    assetHead: null,
    propertyType: null,
    assetName: '',
    assetNo: null,
    assetDescription: null,
    owner: null,
    value: null,
    sumInsured: null,
    occupancy: null,
    occupancyCode: null,
    riskDescription: null,
    machineryOrEquipmentName: null,
    replacementValue: null,
    reinstatedOrReplacementValue: null,
    retroActiveDate: null,
    productDetails: null,
    generalAggregateLimit: null,
    productAndCompletedOperationsLimit: null,
    lastYearTurnoverIndia: null,
    lastYearTurnoverOECD: null,
    lastYearTurnoverUSAorCanada: null,
    lastYearTurnoverUKorEurope: null,
    expectedTurnoverIndia: null,
    expectedTurnoverOECD: null,
    expectedTurnoverUSAorCanada: null,
    expectedTurnoverEurope: null,
    personalAndAdvertisingInjuryLimit: null,
    fireDamageLimit: null,
    medicalExpenses: null,
    territory: null,
    jurisdiction: null,
    currencyOfQuote: null,
    productRecallQuaranteeFinancialLoss: null,
    productRecallLimit: null,
    productContamination: null,
    businessInteruption: null,
    consultantAndAdvisorCost: null,
    extortionCost: null,
    rehabilitationExpenses: null,
    thirdPartyRecallExpenses: null,
    contractorNameAndAddress: null,
    nameOfSubContractor: null,
    projectDetailsOrRiskDetails: null,
    projectPeriod: null,
    thirdPartyLiability: null,
    defaultLiabilityPeriod: null,
    descriptionOfProject: null,
    extendedMaintenancePeriod: null,
    firstYearOperationAndMaintenanceCost: null,
    erectionPeriod: null,
    testingPeriod: null,
    majorStructureDetails: null,
    detailsOfConstructionMaterialStorageYard: null,
    wetRisk: null,
    hillyAreas: null,
    undergroundWork: null,
    valueOfWorkOrProjectCost: null,
    sumInsuredBifurcation: null,
    sumInsuredForTemporaryStructures: null,
    sumInsuredOwnProperty: null,
    sumInsuredFLOPSupplierPremises: null,
    sumInsuredFLOP: null,
    sumInsuredMLOP: null,
    noOfEmployees: null,
    categoryOfEmployees: null,
    cashInSafe: null,
    cashAtCounter: null,
    cashInTransit: null,
    perPersonLimit: null,
    annualTransit: null,
    aoaLimit: null,
    aoyLimit: null,
    transitFrom: null,
    transitTo: null,
    distance: null,
    modeOfTransport: null,
    employeesDetails: null,
    registrationNumber: null,
    colour: null,
    seatingCapacity: null,
    chasisNumber: null,
    variant: null,
    cubicCapacity: null,
    nameOfRegistrationAuthority: null,
    idv: null,
    vehicleMake: null,
    vehicleModel: null,
    vehicleVariant: null,
    projectCostIncGst: null,
    landedCostOfImportedItemsIncFi: null,
    expectedDateOfCommencementOfErection: null,
    indigenousPmIncTrans: null,
    importedPmIncTrans: null,
    newMachineryPmIndigenousIncTrans: null,
    newMachineryPmImported: null,
    secondHandIndigenousIndigenous: null,
    secondHandImportedImported: null,
    costOfErectionInclCivilWorks: null,
    totalValueOfMachinery: null,
    journeyStartDate: null,
    journeyEndDate: null,
    cargoSumInsuredInvRel: null,
    riskCovered: null,
    modeOfTransit: null,
    packing: null,
    territoryAndJurisdiction: null,
    reinstatement: null,
    projectPeriodRf: null,
    premisesOperationsLiability: null,
    damageToThePremisesRented: null,
    imports: null,
    domesticPurchases: null,
    domesticTransfers: null,
    domesticSales: null,
    exports: null,
    capitalGoods: null,
    scopeOfCover: null,
    landedCostOfIndigenousItemsIncFi: null,
    packingRf: null,
    policyId,
    groupId,
    savedStatus: false,
    actionType: 'create'
});
